/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A single step in the onboarding section
 * @export
 * @interface OnboardingStepDetails
 */
export interface OnboardingStepDetails {
    /**
     * 
     * @type {string}
     * @memberof OnboardingStepDetails
     */
    header: string;
    /**
     * 
     * @type {string}
     * @memberof OnboardingStepDetails
     */
    description: string;
    /**
     * Reference to Asset for step icon
     * @type {string}
     * @memberof OnboardingStepDetails
     */
    icon?: string;
}

/**
 * Check if a given object implements the OnboardingStepDetails interface.
 */
export function instanceOfOnboardingStepDetails(value: object): value is OnboardingStepDetails {
    if (!('header' in value) || value['header'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function OnboardingStepDetailsFromJSON(json: any): OnboardingStepDetails {
    return OnboardingStepDetailsFromJSONTyped(json, false);
}

export function OnboardingStepDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): OnboardingStepDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'header': json['header'],
        'description': json['description'],
        'icon': json['icon'] == null ? undefined : json['icon'],
    };
}

export function OnboardingStepDetailsToJSON(json: any): OnboardingStepDetails {
    return OnboardingStepDetailsToJSONTyped(json, false);
}

export function OnboardingStepDetailsToJSONTyped(value?: OnboardingStepDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'header': value['header'],
        'description': value['description'],
        'icon': value['icon'],
    };
}

